import React from "react"
import ContentCard from "../molecules/ContentCard"
import { H3, mixins } from '../../components/css-variables'
import { css } from 'styled-components'


/**
 * from Zac's functional description in Jira (ARW-80)
 * 
 * Exists on both the resource template and the news/updates template.
 * 
 * Related content could be the following post types: posts, pages or resources.
 * Pulls in the content by the following criteria (most recent in order if the first criteria are not met):
 * Categorically related content of the same post type (ex. a resource associated with “Stewardship” will pull in the same, a news item associated with “Supporter Data” will pull in the same)
 * Categorically related of a different post type (ex. a resource associated with “Stewardship” might pull in the stewardship What We Do page or a )
 * Similar Content types (Policy, Best Practice etc.) even if unrelated by category
 * No categories need to be prioritized over others of what is shown first if there are multiple terms applied to the item (if “Stewardship” and “Engaging Supporters” are both applied to the post, for example).
 * Shows 3 related content items based on the above criteria. If 3 items can’t be drawn in based on the above criteria, show no items nor the related content label.
 *  
 * */ 

 let headingCss = css`
 ${mixins.fixed_width_element}
 ${mixins.fixed_width_content_pad}
`


const RelatedContentCards = ({ type, categories, id, relatedContentOverride }) => {

    const category = categories.nodes[0]

    //console.log(categories)

    let primaryNodes  = null
    let secondaryNodes = null
    let ternaryNodes = null

    let cardCollection = []
    switch(type) {
        case 'resources':
            primaryNodes = category.resources.nodes
            secondaryNodes = category.pages.nodes
            ternaryNodes = category.posts.nodes
            break;
        case 'pages':
            primaryNodes = category.pages.nodes
            secondaryNodes = category.resources.nodes
            ternaryNodes = category.posts.nodes
            break;
        case 'posts':
        default:
            primaryNodes = category.posts.nodes
            secondaryNodes = category.resources.nodes
            ternaryNodes = category.pages.nodes
            break;
    }

    cardCollection = relatedContentOverride?.relatedContentField && relatedContentOverride.relatedContentField.length > 0 ? 
        relatedContentOverride.relatedContentField.map(item => item.relatedContentItems) : 
            primaryNodes.concat(secondaryNodes, ternaryNodes).filter(item => item.id !== id).slice(0,3)

    //console.log(cardCollection)
    
    return (cardCollection.length <= 3 && cardCollection.length > 0)
        ? (
            <section>
                <header css={headingCss}><H3 className="alt" >Related Content</H3></header>
                
                { cardCollection.map((item) => {
                    return  <ContentCard {...item} key={item.id}/>
                })}
            </section>

        )
        : null
}


 export default RelatedContentCards